export default function () {
  this.$el = $('#gradebook-quick-actions')
  this.ungraded = ko.observable(null)
  this.courseId = $('#course_id').val()

  this.initUngradedSummaryPanel = () => {
    if (this.$el.length) {
      Kadenze.Ajax.get({
        routeName: 'ungraded_course_gradebook_summary_index_path',
        routeParams: this.courseId,

        //
        // TODO: really should do a 5 minute timeout?
        //
        // timeout: 1000 * 60 * 5,

        progressBar: {
          template: 1,
          start: true,
          parent: '#ungradedSummary'
        },

        done: data => this.ungraded(ko.mapping.fromJS(data)),
      })
    }
  }

  this.getTotalUngradedCount = () => {
    if (!!this.ungraded() && typeof this.ungraded() === 'object') {
      const values = Object.values(this.ungraded())

      values.pop()

      const count = values.reduce((memo, value) => memo + value.count(), 0)
      const reachedMaxCount = !!values.filter(value => value.reached_max_count()).length

      return count + (reachedMaxCount ? '+' : '')
    }
  }

  this.getUngradedGraderPath = item => {
    return Kadenze.Routes.course_gradebook_coursework_grader_path(
      this.courseId,
      item.slug(),
      { filters: ['ungraded'] }
    )
  }

  this.trackGradingAction = () => {
    Kadenze.Analytics.track('instructor_ui', 'dashboard_quick_actions_click', {})

    Kadenze.Analytics.mpTrack('instructor_ui', {
      event: 'dashboard_quick_actions_click'
    })
  }

  (() => this.initUngradedSummaryPanel())()
}
